import React from 'react';

export function CantResolve() {
    return (
        <div style={ { color: 'red' } }>
            Can't resolve
        </div>
    );
}
